const translations = {
  "en": {
    "signal tracked on %{time}": "signal tracked on %{time}"
  },
  "zh-tw": {
    "signal tracked on %{time}": "訊號追蹤時間：%{time}"
  }
};

export default translations;
